import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-message-success",
  "use": "icon-message-success-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 60\" id=\"icon-message-success\">\n<circle fill=\"#084A95\" cx=\"29.535\" cy=\"30.163\" r=\"25\" />\n<polygon fill=\"#FFFFFF\" points=\"33.447,35.762 43.532,23.806 38.607,19.631 28.523,31.591 21.144,25.339 16.975,30.266 29.28,40.69 \n\t29.285,40.687 29.289,40.69 30.859,38.828 33.453,35.769 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol